import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ConversationDetailBlockTypes = {
  TEXT: 'text',
  KEY_VALUE: 'key_value',
  TABLE: 'table',
  LIST: 'list',
  CHIPS: 'chips',
  A2UI: 'a2ui',
} as const

export type ConversationDetailBlockTypeEnum = Enum<
  typeof ConversationDetailBlockTypes
>
